import Airtable from "airtable";

const theChangableBase = new Airtable({apiKey: 'patjcE0Oa54kfWtFE.820c3b5107a690a0160fa2730a0d1a7354c09bdecad6625f180f671b19e2c4e2'}).base('appPrmFJzdWiFnCpN');
export default theChangableBase;


